import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var unsafeWindowObjectRetrieve = function unsafeWindowObjectRetrieve(property) {
  var prop = window[property];
  if (!prop) {
    throw new Error("Failed to find ".concat(property, " on the window!"));
  }
  return prop;
};
export var formUrlEncode = function formUrlEncode(s) {
  return s === null ? "" : encodeURIComponent(s + "");
};
export var getSessionKey = function getSessionKey() {
  var clientState = unsafeWindowObjectRetrieve("clientState");
  return clientState.sessionKey;
};
export var getSessionID = function getSessionID() {
  var _clientState$sessionI;
  var clientState = unsafeWindowObjectRetrieve("clientState");
  return (_clientState$sessionI = clientState.sessionID) !== null && _clientState$sessionI !== void 0 ? _clientState$sessionI : undefined;
};
export var getVersion = function getVersion() {
  var clientState = unsafeWindowObjectRetrieve("clientState");
  return clientState.version;
};
export var genConditionalParams = function genConditionalParams(keyMap) {
  var clientState = unsafeWindowObjectRetrieve("clientState");
  var value = keyMap.reduce(function (acc, cur) {
    var _ref = cur,
      _ref2 = _slicedToArray(_ref, 2),
      csKey = _ref2[0],
      paramsKey = _ref2[1];
    return clientState[csKey] ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, paramsKey, formUrlEncode(clientState[csKey]))) : _objectSpread({}, acc);
  }, {});
  return value;
};
//# sourceMappingURL=internalUtils.js.map